import React from 'react';
import Menu from './Components/menu';
import Banner from './Components/banner';
import Features from './Components/features';
import Testemunho from './Components/ensaios';
import Quemsomos from './Components/quemsomos';
import Footer from './Components/footer';

function Site(){
    return <div>
      <Menu/>
      <Banner/>
      <Features/>
      <Testemunho/>
      <Quemsomos/>
      <Footer/>
    </div>;
  }

export default Site;